import React, { Component } from 'react';
import _ from 'lodash';

import ServiceTable from '../components/ServiceTable';

import ServiceModel from '../components/ServiceModel';

import { Layout, Button, Row, Col, Input, Icon } from 'antd';

class SettingsServicesScreen extends Component {

  state = {    
    dataLoading: true,
    dataAll: [],
    data: [],              
    parkinglocationFormModalVisible: false,    
  }

  componentWillMount() {
    this.loadData();
  }

  loadData(force = false) {
    this.setState({
      dataLoading: true
    });
    ServiceModel.getAll(force)
      .then(data => {        
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });   
      });
  }

  render() {
    return (      
      <Layout.Content style={{ margin: '24px 16px 0' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Systém - Služby</h2>
          <div style={{marginBottom: '20px'}}>
            <Row>
              <Col span={8}>
              </Col>
              <Col span={8} offset={8} style={{textAlign: 'right'}}>
                <Button type="default" onClick={() => { this.loadData(true) }} style={{marginRight: 10}}><Icon type="sync" /></Button>
              </Col>
            </Row>          
          </div>
          <ServiceTable
            data={this.state.data} 
            loading={this.state.dataLoading}
            />            
        </div>
      </Layout.Content>
    );
  }
}

export default SettingsServicesScreen;



// WEBPACK FOOTER //
// ./src/screens/SettingsServicesScreen.js